import React, { useRef } from "react";
import CustomHook from "./CustomHook";
function Home() {
  const scrollTab = useRef();
  CustomHook(scrollTab);

  return (
    <section ref={scrollTab} className="home">
      <div className="content">
        <div className="name">
          MY NAME IS <span>FIRGI</span>
        </div>
        <div className="des">
          {/* 30 */}I am a Programmer and Content Creator with 3 years of
          experience specializing in Front-End Development and Video Editing.
          Passionate about crafting creative and functional digital solutions, I
          excel in creating interactive websites, engaging visual designs, and
          innovative digital projects. My goal is to deliver impactful and
          user-centered results that combine aesthetics with functionality.
        </div>

        <a
          href="/cv.pdf"
          target="_blank"
          rel="noopener noreferrer"
          className="animation active "
        >
          Download My CV
        </a>
      </div>
      <div className="avatar">
        <div className="card">
          <img src="/avatar.png" alt="" />
          <div className="info">
            <div>Frontend</div>
            <div>Indonesia</div>
            <div>12/02</div>
            <div>Male</div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Home;
